import React, { useState } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Navbar from './Navbar'
import Sidebar from "./Sidebar"
import { Padding } from '@mui/icons-material'

const Layout = ({ userData, signout }) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const userId = useSelector((state) => state.global.userId);

  const { data } = {
    data: {
      id: userData?.userId,
      name: userData?.email,
      email: userData?.email,
      role: userData?.["custom:role"],
    }
  }

  return (
    <Box display={isNonMobile ? "flex" : "block"} width="100%" height="100%" bgcolor="#ffffff">
      <Sidebar
        user={userData || {}}
        isNonMobile={isNonMobile}
        drawerWidth="250px"
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <Box flexGrow={1} bgcolor="#ffffff">
        <Navbar
          user={userData || {}}
          signout={signout}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <Box flexGrow={1} bgcolor="#ffffff" p={0}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

export default Layout